/**
 * @file API的Vue插件（方便页面组件内部调用）
 */

import apis from '../common/apis'

apis.install = (Vue) => {
  Vue.prototype.$apis = apis
}

export default apis



// WEBPACK FOOTER //
// ./src/plugins/apis.js